import { ref, computed } from "vue";

const isFreshWater = ref(false);

export const useDomain = () => {
  const domainNumber = computed(() => {
    return isFreshWater.value ? 1 : 0;
  });
  return {
    domainNumber,
    isFreshWater,
  };
};
